<template>
  <ui-modal-layout :title="tr('Intervention required')" :icon="TriangleAlertIcon" tone="warning">
    <!-- Rendered from the bundled markdown guides. -->
    <div
      class="text-sm text-foreground [&_a]:text-primary [&_a]:underline [&_h2]:mt-5 [&_h2]:mb-2 [&_h2]:text-base [&_h2]:font-semibold [&_h2:first-child]:mt-0 [&_h3]:mt-4 [&_h3]:mb-2 [&_h3]:font-semibold [&_li]:mb-2 [&_ol]:mb-3 [&_ol]:list-decimal [&_ol]:pl-5 [&_p]:mb-3 [&_p]:leading-relaxed [&_ul]:mb-3 [&_ul]:list-disc [&_ul]:pl-5"
      v-html="renderedGuide"
    />
  </ui-modal-layout>
</template>

<script>
import { TriangleAlert } from '@lucide/vue';
import { markRaw } from 'vue';

import { getGuideMarkdown } from '@/guides/index.js';
import { renderMarkdown } from '@/utils/markdown.js';

export default {
  name: 'InterventionGuideModal',
  props: {
    interventionCode: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    TriangleAlertIcon: markRaw(TriangleAlert),
  }),
  computed: {
    renderedGuide() {
      const md = getGuideMarkdown(this.interventionCode, this.$root.language);
      if (!md) {
        return '<p>' + this.tr('The guide for this error code is not available. Please contact support.') + '</p>';
      }
      return renderMarkdown(md);
    },
  },
};
</script>
